export default __webpack_public_path__ + "static/media/Perfil-emprendedor.20276ca6.png";